
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
  computed: {
    level1() {
      return this.breadcrumbs && this.breadcrumbs[0]
        ? this.breadcrumbs[0]
        : null
    },
    level2() {
      return this.breadcrumbs && this.breadcrumbs[1]
        ? this.breadcrumbs[1]
        : null
    },
    level3() {
      return this.breadcrumbs && this.breadcrumbs[2]
        ? this.breadcrumbs[2]
        : null
    },
    level4() {
      return this.breadcrumbs && this.breadcrumbs[3]
        ? this.breadcrumbs[3]
        : null
    },
  },
}
